import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  AnalyticsGranularity,
  AnalyticsCustomersGroupBy,
  AnalyticsResponse,
  AnalyticsGroupBy,
  AnalyticsCustomers
} from "src/app/backend/models/analytics";
import { environment } from "src/environments/environment";

@Injectable()
export class AnalyticsCustomersBackend {
  private readonly http = inject(HttpClient);

  list({
    from,
    to,
    granularity,
    groupBy
  }: {
    from: string;
    to: string;
    granularity: AnalyticsGranularity | "none";
    groupBy: AnalyticsGroupBy;
  }): Observable<AnalyticsResponse<AnalyticsCustomers>> {
    return this.http
      .get<AnalyticsResponse<AnalyticsCustomers>>(
        `${environment.snoots.api.analytics}/customers`,
        {
          params: {
            from,
            to,
            granularity,
            groupBy
          }
        }
      )
      .pipe(
        map((response) => ({
          ...response,
          totalAverage: response.totalAverage || 0
        }))
      );
  }

  export(params: {
    from: string;
    to: string;
    granularity: AnalyticsGranularity | "none";
    groupBy: AnalyticsCustomersGroupBy;
  }): Observable<void> {
    return this.http.post<void>(
      `${environment.snoots.api.analytics}/customers/exports`,
      {
        from: params.from,
        to: params.to,
        granularity: params.granularity,
        groupBy: params.groupBy
      }
    );
  }
}
